import { useState } from 'react';
import FilterBar from '../../../shared/components/patterns/FilterBar';
export default function AdminBillingPage() {
  const [period, setPeriod] = useState('month');
  return (
    <section className="control-plane-page">
      <header className="control-plane-topbar">
        <div>
          <div className="control-plane-topbar__title">Bilancio</div>
          <div className="control-plane-topbar__subtitle">
            Billing platform non ancora collegato a una fonte dati reale
          </div>
        </div>

      </header>

      <div className="control-plane-content">
        <section className="control-plane-metrics control-plane-metrics--4">
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">MRR</div>
            <div className="control-plane-metric__value">—</div>
            <div className="control-plane-metric__support">backend non ancora collegato</div>
          </article>
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">Entrate una tantum</div>
            <div className="control-plane-metric__value">—</div>
            <div className="control-plane-metric__support">dato non disponibile</div>
          </article>
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">Uscite</div>
            <div className="control-plane-metric__value">—</div>
            <div className="control-plane-metric__support">dato non disponibile</div>
          </article>
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">Margine netto</div>
            <div className="control-plane-metric__value">—</div>
            <div className="control-plane-metric__support">placeholder operativo</div>
          </article>
        </section>
        <FilterBar config={{ label: 'Filtri bilancio', groups: [{ key: 'period', label: 'Periodo', selection: 'single', emptyValue: 'month', options: [
          { value: 'month', label: 'Ultimi 30 giorni' }, { value: 'quarter', label: 'Ultimo trimestre' }, { value: 'year', label: 'Anno corrente' },
        ] }] }} values={{ period }} onChange={(_, value) => setPeriod(value)} onReset={() => setPeriod('month')} />


        <section className="control-plane-billing-grid">
          <section className="control-plane-billing-block">
            <div className="control-plane-card__header">
              <div>
                <div className="control-plane-card__title">Entrate ricorrenti</div>
                <div className="control-plane-card__subtitle">Billing platform non ancora collegato.</div>
              </div>
            </div>
            <div className="control-plane-billing-list">
              <div className="control-plane-billing-row"><span>Canoni attivi</span><strong>—</strong></div>
              <div className="control-plane-billing-row"><span>Add-on</span><strong>—</strong></div>
              <div className="control-plane-billing-row"><span>Totale</span><strong>—</strong></div>
            </div>
          </section>

          <section className="control-plane-billing-block">
            <div className="control-plane-card__header">
              <div>
                <div className="control-plane-card__title">Uscite</div>
                <div className="control-plane-card__subtitle">Fonte dati reale non disponibile.</div>
              </div>
            </div>
            <div className="control-plane-billing-list">
              <div className="control-plane-billing-row"><span>Infrastruttura</span><strong>—</strong></div>
              <div className="control-plane-billing-row"><span>Licenze</span><strong>—</strong></div>
              <div className="control-plane-billing-row"><span>Totale</span><strong>—</strong></div>
            </div>
          </section>
        </section>

        <section className="control-plane-card">
          <div className="control-plane-card__header">
            <div>
              <div className="control-plane-card__title">Attivazioni</div>
              <div className="control-plane-card__subtitle">Attivazioni una tantum non ancora collegate.</div>
            </div>
          </div>
          <div className="control-plane-empty-state">
            Billing platform non ancora collegato a una fonte dati reale.
          </div>
        </section>
      </div>
    </section>
  );
}
